export const ADD_NEW_EXPORT_JOB = 'ADD_NEW_EXPORT_JOB';
export const UPDATE_EXPORT_JOB_STATUS = 'UPDATE_EXPORT_JOB_STATUS';
export const DISMISS_AND_CLEAR_JOB = 'DISMISS_AND_CLEAR_JOB';
export const UPDATE_ACTIVE_TOAST_ID = 'UPDATE_ACTIVE_TOAST_ID';
export const CACHE_JOB_BEEN_CHECKED = 'CACHE_JOB_BEEN_CHECKED';